import MyRouter from "./routers/index";
import "./App.css";
import { Toaster } from "./components/ui/toaster";
import Cookies from "./components/Cookies/cookies";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <div className="text-base bg-white dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <AuthProvider>
        <Toaster />
        <MyRouter />
        <Cookies />
      </AuthProvider>
    </div>
  );
}

export default App;
